import React from "react";
import { HotelData } from "../../context/searchProvider";
import { cn, formatCurrency } from "@/lib/utils";
import { Minus } from "lucide-react";

type Props = {
  hotel: HotelData;
  isHovered?: boolean;
  zIndex: number;
  // Caller-resolved nightly rate that respects active search filters
  // (isRefundable / roomType / bedType). Marker renders in a detached
  // createRoot tree and can't read useSearch() itself — see GON-5654.
  displayNightlyRate?: number;
};

const HotelMarker: React.FC<Props> = ({
  hotel,
  isHovered,
  zIndex,
  displayNightlyRate,
}) => {
  // Use only the filter-aware displayNightlyRate — no fallback to
  // hotel.nightlyRate. With filters active, a fallback would show the
  // unfiltered rate on the pin while the list card shows nothing, leading
  // to GON-5654-style mismatches.
  const price =
    displayNightlyRate != null
      ? formatCurrency(displayNightlyRate, hotel.lowestRateCurrency, 0)
      : null;

  return (
    <div
      className={cn(
        "marker-shadow flex gap-1 rounded-full border border-pure-black/5 px-4 py-2",
        isHovered
          ? "bg-pure-black text-pure-white"
          : "bg-pure-white text-pure-black"
      )}
      style={{ zIndex }}
    >
      {price ? (
        price
      ) : (
        <Minus
          size={16}
          className={isHovered ? "text-pure-white" : "text-pure-black"}
        />
      )}
    </div>
  );
};

export default HotelMarker;
